import { defineComponent as _defineComponent } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import {
  MAX_LICENSE_HISTORIES,
  MAX_LICENSE_LENGTH,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumeLicenseCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const formatData = useEnglishResumeFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useEnglishResumeHistoriesApi()

return { __sfc: true,formatData, activeHistoryItem, addLicenseHistory, deleteLicenseHistory, moveLicenseHistory, activateHistoryItem, HistoryItem, MAX_LICENSE_HISTORIES, MAX_LICENSE_LENGTH }
}

})